export default "__VITE_ASSET__CLDOytj5__"